import React from "react";

// Types
import ApiError from "../../types/ApiError";
import Member from "../../types/Member";
import Question from "../../types/Question";

// Context

// Services
import ApiService from "../../services/ApiService";

// API
import { UpdateMemberRequest } from "../../api/requests";

// Components
import { IonBadge, IonIcon, IonImg, IonLabel, IonProgressBar, IonSpinner } from "@ionic/react";
import withSendbird from "@wearesweet/sendbird-uikit-react/withSendbird";
import ModalConfirmation from "../Modals/ModalConfirmation";
import ModalFieldForm from "../Modals/ModalFieldForm";

// Utils
import { faPenToSquare } from "@fortawesome/pro-light-svg-icons";
import { faMessageLines } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import sendBirdSelectors from "@wearesweet/sendbird-uikit-react/sendbirdSelectors";
import { cogOutline } from "ionicons/icons";
import _ from "lodash";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { debug } from "../../App";
import { AuthenticatedUserContext } from "../../contexts/AuthenticatedUserContext";
import { dataURItoBlob } from "../../utils/dataUriToBlob";
import IconButton from "../Button/Icon/IconButton";
import { ImageUploadModal } from "../ImageUploadModal/ImageUploadModal";

class ProfileHeader extends React.Component<{ member: Member | null } | any, any> {
  constructor(props: Readonly<any>) {
    super(props);

    this.state = {
      modalFieldFormShow: false,
      modalConfirmationShow: false,
      modalEditImageShow: false,
      showProfileImageModal: false,
      showCoverImageModal: false,
      form: {},
      updatingCoverImage: false,
      updatingProfileImage: false,
      updatedCoverImage: null,
      updatedProfileImage: null,
      progress: -1,
    };
  }

  saveImage(image: string, type: string) {
    debug("ProfileHeader", "saveProfileImage");

    const formData = new FormData();
    formData.append(type, dataURItoBlob(image), "profile.jpg");

    return new Promise<void>(async (resolve, reject) => {
      this.setState({ showProfileImageModal: false, showCoverImageModal: false });

      // we have to use XMLHttpRequest to get the progress
      const xhr = new XMLHttpRequest();
      const token = await ApiService.getToken();

      xhr.open("POST", `${ApiService.baseUrl}/members/${this.props.member.id}/images`);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      xhr.upload.onprogress = (event) => {
        const progress = event.lengthComputable ? event.loaded / event.total : 0;
        this.setState({ progress });
      };
      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve();
        } else {
          reject();
        }

        this.setState({ progress: -1 });
      };
      xhr.send(formData);
    });
  }

  saveProfileImage(image: string) {
    this.setState({
      updatingProfileImage: true,
    });

    this.saveImage(image, "profile_image").then(() => {
      this.setState({
        updatingProfileImage: false,
        updatedProfileImage: image,
      });
    });
  }

  saveCoverImage(image: string) {
    this.setState({
      updatingCoverImage: true,
    });

    this.saveImage(image, "action_image").then(() => {
      this.setState({
        updatingCoverImage: false,
        updatedCoverImage: image,
      });
    });
  }

  render() {
    const { authenticatedMember, member, className, t } = this.props;
    const actionImgPath = this.state.updatedCoverImage || member?.action_thumbnail || "assets/action-image.png";
    const profileImgPath = this.state.updatedProfileImage || member?.profile_thumbnail || "assets/profile-image.png";

    return (
      member && (
        <div className={[className, 0 && authenticatedMember?.is_admin ? "profile__header--admin" : null, "profile__header", "bg--black"].filter(Boolean).join(" ")}>
          {this.state.progress > -1 && (
            <div className={"profile__header--uploading"}>
              <IonLabel>Uploading your photo...</IonLabel>
              <IonProgressBar value={this.state.progress} />
            </div>
          )}

          <ImageUploadModal
            isOpen={this.state.showProfileImageModal}
            onDidDismiss={() => {
              this.setState({ showProfileImageModal: false });
            }}
            save={this.saveProfileImage.bind(this)}
            currentImage={profileImgPath}
            circle={true}
            options={{
              aspectRatio: 1,
            }}
            previewImageClassName={"profile-image"}
            title="Profile Photo"
          />
          <ImageUploadModal
            isOpen={this.state.showCoverImageModal}
            onDidDismiss={() => {
              this.setState({ showCoverImageModal: false });
            }}
            currentImage={actionImgPath}
            circle={false}
            options={{
              aspectRatio: 4,
            }}
            save={this.saveCoverImage.bind(this)}
            title="Cover Photo"
          />

          <div className="profile__images-wrap">
            <FontAwesomeIcon icon={faPenToSquare} className={"profile__images-edit-cover-image"} onClick={this.showCoverImageModal.bind(this)} />
            <div className={`profile__image-cover ${actionImgPath ? "has-image" : "default"}`} style={{ backgroundImage: this.state.updatingCoverImage ? "" : `url(${actionImgPath})` }}>
              {this.state.updatingCoverImage ? <IonSpinner name="dots" /> : ""}
            </div>
            <button className={"profile-image"} onClick={this.showProfileImageModal.bind(this)} type="button">
              {this.state.updatingProfileImage ? <IonSpinner name="dots" /> : <IonImg src={profileImgPath} className="image-circled profile-image image-circled-action image--circled-action--edit" />}
            </button>
          </div>

          <div className="wrapper ion-padding">
            <div>
              <h1 className="profile__name ion-text-uppercase">
                {member?.athlete?.nickname || t("myProfile")}
                <IonIcon
                  className={"profile__images-settings"}
                  icon={cogOutline}
                  onClick={() => {
                    this.props.history.push("/account");
                  }}
                />
                {/** @ts-ignore */}
                {this.context?.numUnreadFiles > 0 && (
                  <IonBadge
                    color={"danger"}
                    style={{
                      padding: "3px 5px 3px 7px",
                      marginLeft: "4px",
                      textAlign: "center",
                      position: "relative",
                      top: "4px",
                    }}
                    onClick={() => {
                      this.props.history.push("/account");
                    }}
                  >
                    {/** @ts-ignore */}
                    {this.context.numUnreadFiles}
                  </IonBadge>
                )}
                {this.state?.form.questions?.[0] !== undefined && <FontAwesomeIcon icon={faPenToSquare} className="profile__icon" onClick={this.toggleModalFieldForm} />}
                {this.state?.form.questions?.[0] !== undefined && this.renderModalField()}
                {!authenticatedMember?.is_admin ? this.renderRequestReceivedModal() : ""}
              </h1>
              {!authenticatedMember?.is_admin ? <p>{t("editProfileExplaination")}</p> : ""}
            </div>
            {authenticatedMember?.is_admin && authenticatedMember.id !== member.id ? <IconButton icon={faMessageLines} tooltip={t("chatWith")} align="left" onClick={this.chatWith} /> : ""}
          </div>
        </div>
      )
    );
  }

  chatWith = () => {
    const { authenticatedMember, member, t } = this.props;

    this.setState({ chatLoading: true });

    if (this.props.sb !== null) {
      const { groupChannel } = this.props.sb;

      const newChannelParams = {
        invitedUserIds: [authenticatedMember.id.toString(), member.id.toString()],
      };

      groupChannel
        .createChannel(newChannelParams)
        .then((channel: any) => {
          this.setState({ chatLoading: false });
          // @ts-ignore
          this.props.history.push(`/chat/channels/${channel.url}`);
        })
        .catch((error: any) => alert(`${t("openChatError")}: ${error}`));
    } else {
      alert(t("openChatError"));
    }
  };

  showProfileImageModal(): void {
    if (!this.state.updatingProfileImage) {
      this.setState({ showProfileImageModal: true });
    }
  }

  showCoverImageModal(): void {
    if (!this.state.updatingCoverImage) {
      this.setState({ showCoverImageModal: true });
    }
  }

  renderModalField = () => {
    const field = this.state?.form.questions?.[0];
    const { t } = this.props;

    return (
      <ModalFieldForm
        type="secondary"
        isOpen={this.state.modalFieldFormShow}
        heading="Edit Details"
        closeModal={this.toggleModalFieldForm}
        field={field}
        buttons={[
          { text: t("cancel"), onClick: this.toggleModalFieldForm, className: "button button--wire-white" },
          { text: t("update"), onClick: () => this.handleSubmit(field) },
        ]}
      />
    );
  };

  renderRequestReceivedModal = () => {
    const field = this.state.form.questions?.[0];
    const { t } = this.props;

    return (
      <ModalConfirmation
        isOpen={this.state.modalConfirmationShow}
        closeModal={this.toggleModalConfirmation}
        heading={
          <>
            {t("request")} <span className="color-red">{t("recieved")}</span>
          </>
        }
        text={
          <>
            <p className="text-large ion-text-uppercase ion-color-light">{field?.name}</p>
            <p>{t("changeRequestedMemberConfirmation")}</p>
          </>
        }
        buttons={[{ text: "OK", onClick: this.toggleModalConfirmation }]}
      />
    );
  };

  toggleModalFieldForm = () => this.setState({ modalFieldFormShow: !this.state.modalFieldFormShow });

  toggleModalConfirmation = () => this.setState({ modalConfirmationShow: !this.state.modalConfirmationShow });

  handleSubmit = async (field: Question) => {
    const { member, authenticatedMember } = this.props;
    const { form } = this.state;

    const payload: object = {};
    _.set(payload, [field.scope, field.key].filter((k) => k).join("."), field.value);

    await UpdateMemberRequest(await member, form, payload)
      .then(() => {
        this.toggleModalFieldForm();
        if (authenticatedMember?.is_admin) {
          // Refresh profile data
          this.props.updateProfileRequest();
          this.forceUpdate();
        } else {
          this.toggleModalConfirmation();
        }
      })
      .catch((err: ApiError) => {
        console.error(err);
        this.setState({ errors: err.errors, message: err.message, loading: false });
      });
  };
}

ProfileHeader.contextType = AuthenticatedUserContext;

const ProfileHeaderWithSendbird: any = withSendbird(ProfileHeader, (state: any) => ({
  sb: sendBirdSelectors.getSdk(state),
  connect: sendBirdSelectors.getConnect(state),
}));

const firstHoc = withRouter(ProfileHeaderWithSendbird);
export default withTranslation()(firstHoc);
